var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquityimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    stroke: "#D5D7DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_2519_36904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 7.58172 8.58172 4 13 4H37C41.4183 4 45 7.58172 45 12V36C45 40.4183 41.4183 44 37 44H13C8.58172 44 5 40.4183 5 36V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 3.5C41.6944 3.5 45.5 7.30558 45.5 12V36C45.5 40.6944 41.6944 44.5 37 44.5H13C8.30558 44.5 4.5 40.6944 4.5 36V12C4.5 7.30558 8.30558 3.5 13 3.5H37Z",
    stroke: "black",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 32V25M25 32V22M17 32L17 28M26.4067 17.0275L31.5751 18.9657M23.7988 17.4009L18.2002 21.5998M34.0607 18.4393C34.6464 19.0251 34.6464 19.9749 34.0607 20.5607C33.4749 21.1464 32.5251 21.1464 31.9393 20.5607C31.3536 19.9749 31.3536 19.0251 31.9393 18.4393C32.5251 17.8536 33.4749 17.8536 34.0607 18.4393ZM18.0607 21.4393C18.6464 22.0251 18.6464 22.9749 18.0607 23.5607C17.4749 24.1464 16.5251 24.1464 15.9393 23.5607C15.3536 22.9749 15.3536 22.0251 15.9393 21.4393C16.5251 20.8536 17.4749 20.8536 18.0607 21.4393ZM26.0607 15.4393C26.6464 16.0251 26.6464 16.9749 26.0607 17.5607C25.4749 18.1464 24.5251 18.1464 23.9393 17.5607C23.3536 16.9749 23.3536 16.0251 23.9393 15.4393C24.5251 14.8536 25.4749 14.8536 26.0607 15.4393Z",
    stroke: "#111827",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_2519_36904",
    x: 0,
    y: 1,
    width: 52,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2519_36904"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2519_36904",
    result: "effect2_dropShadow_2519_36904"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2519_36904",
    result: "effect3_dropShadow_2519_36904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2519_36904",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_2519_36904"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityimage);
export default __webpack_public_path__ + "static/media/equityimage.6457fde4ee98ffff4f0decc5cf3c7a05.svg";
export { ForwardRef as ReactComponent };